import React from 'react';
import { FORM_STEPS } from '../types/mortgage';

interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({ currentStep }) => {
  return (
    <div>
      {FORM_STEPS.map((step, index) => (
        <React.Fragment key={step.id}>
          <div>
            <div>
              {currentStep > step.id ? '✓' : step.id}
            </div>
            <div>
              <div>{step.title}</div>
            </div>
          </div>
          {index < FORM_STEPS.length - 1 && (
            <div />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProgressIndicator; 